module.exports = __webpack_public_path__ + "static/media/ev2.31c67922.jpg";